// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3DNLW","location":"Header_location__U2Zr6"};